<template>
  <div class="address-location">
    <div class="header">
      <navigation :title="'客户地址'" :onBack="pageBack" />
      <div class="city-search">
        <span class="city-name" @click="switchCity">{{ getCity }}</span>
        <img src="@assets/images/arrow_down.png" alt="" class="arrow" />
        <address-search
          ref="inputCode"
          :placeholder="'请输入地址'"
          :addressSearch="addressSearch"
        ></address-search>
      </div>
    </div>
    <div class="content">
      <div class="title">当前地址</div>
      <div class="location-area">
        <div class="info" v-if="!getPositionStatus">正在定位...</div>
        <div
          class="address-info"
          v-else
          @click="sendAddress(getCurrentLocation)"
        >
          {{ getCurrentLocation.name }}
        </div>
        <div class="btn" @click="reLocate">
          <img src="@assets/images/location.png" alt="" />
          <span class="btn-word">重新定位</span>
        </div>
      </div>
      <div class="address-list">
        <div class="title mgb">附近地址</div>
        <sliding-list :addressList="list" :callBack="sendAddress" />
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@components/NewComponents/Navigation/Navigation.vue';
import AddressSearch from '@components/AddressSearch/AddressSearch.vue';
import SlidingList from '@components/SlidingList/SlidingList.vue';
import store from '@stores';
// 已迁移至百度地图
import bmapService from '@stores/location/bmap';

export default _extend({
  name: 'AddressLocation',
  components: {
    Navigation,
    AddressSearch,
    SlidingList
  },
  data() {
    return {
      searchStatus: false,
      amapInstance: bmapService // 保持变量名兼容
    };
  },
  props: {
    updateNearBy: {
      type: Function,
      default: () => {}
    },
    switch: {
      type: Function,
      default: () => {}
    },
    nearBy: {
      type: Array,
      default: []
    },
    location: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    sendAddress(item) {
      const { name, address } = item;
      this.$store.commit(
        store.VX_TYPES.FORM.UPDATE_LOCATION_STREET,
        address + name
      );
      this.$store.commit(store.VX_TYPES.FORM.UPDATE_SHOW_LOCATION, false);
    },
    pageBack() {
      this.$store.commit(store.VX_TYPES.FORM.UPDATE_SHOW_LOCATION, false);
    },
    switchCity() {
      this.switch('citySelection');
    },
    reLocate() {
      this.searchStatus = false;
      // 上次定位还没结束
      if (!this.$store.state.location.positionStaus) {
        return;
      }
      this.location();
    },
    // 定位地址解析
    analyzeAddress(res) {
      const { pois } = res;
      const nearByAddress = [];
      pois.forEach(item => {
        let obj = {
          name: '',
          address: ''
        };
        obj.name = item.name;
        if (item.address && !item.address.length) {
          obj.address = '';
        } else {
          obj.address = item.address;
        }
        nearByAddress.push(obj);
      });
      return {
        nearBy: nearByAddress
      };
    },
    addressSearch(value) {
      const { selectedCity } = this.$store.state.location;
      this.amapInstance.placeSearch.setCity(selectedCity);
      this.searchStatus = true;

      this.amapInstance.search(value, (status, result) => {
        if (status === 'complete') {
          let list = this.analyzeAddress(result.poiList);
          const { cityName, selectedCity } = this.$store.state.location;
          if (cityName !== selectedCity) {
            this.$store.commit(store.VX_TYPES.LOCATION.UPDATE_LOCALADDRESS, []);
          }
          this.updateNearBy(list.nearBy);
        }
      });
    }
  },
  computed: {
    getCity() {
      let city = this.$store.state.location.selectedCity;
      if (this.$store.state.location.city !== city) {
        this.updateNearBy([]);
        this.$store.commit(store.VX_TYPES.LOCATION.UPDATE_CURRENT, {});
      }
      if (city.length < 4) {
        return city;
      } else {
        return city.substring(0, 3) + '...';
      }
    },
    getPositionStatus() {
      return this.$store.state.location.positionStaus;
    },
    getCurrentLocation() {
      return this.$store.state.location.current;
    },
    addressList() {
      return this.$store.state.location.nearBy;
    },
    list() {
      let city = this.$store.state.location.selectedCity;
      if (this.$store.state.location.city !== city && !this.searchStatus) {
        return [];
      } else {
        return this.nearBy;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import './AddressLocation.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/Location/AddressLocation/AddressLocation.vue